"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const articles = [
  {
    slug: "window-repair-cost-miami",
    esSlug: "costo-reparacion-ventanas-miami",
    img: "Pricing+Guide",
  },
  {
    slug: "impact-windows-vs-shutters",
    esSlug: "ventanas-impacto-vs-persianas",
    img: "vs+Shutters",
  },
  {
    slug: "insurance-discount-impact-windows",
    esSlug: "descuento-seguro-ventanas-impacto",
    img: "Insurance+Savings",
  },
  {
    slug: "hvhz-code-noa-explained",
    esSlug: "codigo-hvhz-noa-explicado",
    img: "Codes+Guide",
  },
  {
    slug: "salt-air-hardware-failure",
    esSlug: "aire-salino-herrajes-miami",
    img: "Salt+Air+Hardware",
  },
];

export default function ArticlesGrid() {
  const { t, currentLang } = useLanguage();
  const isEs = currentLang === "es";

  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-6">
        <h2 className="mb-12 text-center text-3xl font-bold text-[#064e3b]">
          {t("blog.allArticlesHeading")}
        </h2>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => {
            const titleKey =
              a.slug === "window-repair-cost-miami"
                ? "blog.articleCost.title"
                : a.slug === "impact-windows-vs-shutters"
                  ? "blog.articleShutters.title"
                  : a.slug === "insurance-discount-impact-windows"
                    ? "blog.articleInsurance.title"
                    : a.slug === "hvhz-code-noa-explained"
                      ? "blog.articleCodes.title"
                      : "blog.salt.h1";
            const excerptKey =
              a.slug === "window-repair-cost-miami"
                ? "blog.articleCost.excerpt"
                : a.slug === "impact-windows-vs-shutters"
                  ? "blog.articleShutters.excerpt"
                  : a.slug === "insurance-discount-impact-windows"
                    ? "blog.articleInsurance.excerpt"
                    : a.slug === "hvhz-code-noa-explained"
                      ? "blog.articleCodes.excerpt"
                      : "blog.articleSalt.excerpt";
            const catKey =
              a.slug === "window-repair-cost-miami"
                ? "blog.articleCost.category"
                : a.slug === "impact-windows-vs-shutters"
                  ? "blog.articleShutters.category"
                  : a.slug === "insurance-discount-impact-windows"
                    ? "blog.articleInsurance.category"
                    : a.slug === "hvhz-code-noa-explained"
                      ? "blog.articleCodes.category"
                      : "blog.articleSalt.category";
            const linkPath = isEs
              ? `/es/blog/${a.esSlug}/`
              : `/blog/${a.slug}/`;

            return (
              <div
                key={a.slug}
                className="overflow-hidden rounded-lg border border-[#064e3b]/10 bg-white transition hover:shadow-xl"
              >
                <img
                  src={`https://placehold.co/400x250/064e3b/fbbf24?text=${a.img}`}
                  alt={String(t(titleKey))}
                  className="h-[200px] w-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src =
                      "https://placehold.co/400x250/064e3b/fbbf24?text=Article";
                  }}
                />
                <span className="mx-6 mt-4 inline-block rounded bg-[#fbbf24] px-3 py-1 text-xs font-bold uppercase tracking-widest text-[#064e3b]">
                  {t(catKey)}
                </span>
                <h3 className="mx-6 mt-3 text-xl font-bold text-[#064e3b]">
                  {t(titleKey)}
                </h3>
                <p className="mx-6 mt-2 text-sm leading-relaxed text-[#064e3b]/70">
                  {t(excerptKey)}
                </p>
                <Link
                  to={linkPath}
                  className="mx-6 mb-6 mt-4 inline-block text-sm font-semibold text-[#047857] transition hover:text-[#ea580c]"
                >
                  {t("blog.readMore")}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}